<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addCourse" style="width: 96px">新增科目</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="bookName" label="科目名称"></el-table-column>
                    <el-table-column label="科目图片">
                        <template slot-scope="scope">
                            <el-image style="width: 60px;height: 60px" :src="scope.row.imagePath"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editCourse(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增科目" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="courseAdd" :rules="addRules" ref="addCourse">
                <el-form-item label="科目名称" label-width="100px" prop="bookName" size="small">
                    <el-input v-model="courseAdd.bookName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="科目图片" label-width="100px" size="small" prop="imagePath">
                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                        <i class="el-icon-plus push"></i>
                        <el-image v-if="courseAdd.imagePath" class="course-img" :src="courseAdd.imagePath"></el-image>
                        <input type="file" class="upload-input" @change="uploadImg" accept="image/*" ref="picture"/>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑科目" :visible.sync="dialogEditVisible" width="520px" :close-on-click-modal="false">
            <el-form :model="courseEdit"  ref="editCourse" size="small">
                <el-form-item label="科目名称" label-width="100px" prop="courseName">
                    <el-input v-model="courseEdit.bookName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="科目图片" label-width="100px" size="small">
                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                        <i class="el-icon-plus push"></i>
                        <el-image v-if="courseEdit.imagePath" class="course-img" :src="courseEdit.imagePath"></el-image>
                        <input type="file" class="upload-input" @change="editImg" accept="image/*" ref="editPicture"/>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px;">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                // 表格信息
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                file:'',
                fileUrl: '',
                // 新增诊断弹窗数据
                courseAdd:{
                    bookName: '',
                    imagePath: '',
                },
                addRules: {
                    // bookName: [{required: true, message: '请输入科目名称', trigger: 'blur'}],
                    // imagePath: [{required: true, message: '请选择科目图片', trigger: 'change'}],
                },
                // 编辑诊断弹窗数据
                courseEdit:{
                    bookName: '',
                    imagePath: '',
                },
            }
        },
        methods: {
            // 获取诊断列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    bookName: '',
                }
                this.axios.post('/api-b/10029/100013',params,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if(res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                        }
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(()=>{
                    this.$refs.addCourse.resetFields()
                });
            },
            // 打开新增弹窗
            addCourse() {
                this.dialogAddVisible =true
                this.$nextTick(()=>{
                    this.$refs.addCourse.resetFields();
                });
            },
            uploadImg() {
                let inputDOM = this.$refs.picture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                this.axios.post('/api-f/10027/100065',params,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.courseAdd.imagePath = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确定添加诊断
            confirmAdd() {
                this.$refs.addCourse.validate(valid => {
                    if (valid) {
                        let params = {
                            bookName: this.courseAdd.bookName,
                            imagePath: this.courseAdd.imagePath
                        }
                        this.axios.post('/api-b/10029/100014',params,{
                            headers:{
                                Authorization: this.authorization,
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })

            },
            // 打开编辑诊断弹窗
            editCourse(data) {
                this.dialogEditVisible = true
                this.courseEdit = JSON.parse(JSON.stringify(data))
            },
            editImg() {
                let inputDOM = this.$refs.editPicture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                this.axios.post('/api-f/10027/100065',params,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.courseEdit.imagePath = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认编辑诊断
            confirmEdit() {
                let params = {
                    bookId: this.courseEdit.bookId,
                    bookName: this.courseEdit.bookName,
                    imagePath: this.courseEdit.imagePath
                }
                this.axios.put('/api-b/10029/100076',params,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 删除诊断
            deleteCourse(date) {
                this.$confirm('您确认要删除此科目?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.delete('/api-b/10029/100019/' + date.bookId,{
                        headers:{
                            token: this.authorization
                        }
                    }).then(res =>{
                        if(res.data.code === 10000) {
                            this.$message.success(res.data.message);
                            this.getData()
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(error => {
                        this.$message.error(error.message);
                    });
                })
            }
        },
        created() {
            this.getData()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
    .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>